export default {
    "comma-sscm-local-57": "http://192.168.2.57:8088",
    "comma-sscm-local-250-http": "http://baiyun.smartcomma.com",
    "comma-online": "https://tms.baiyun.com.cn:8663"
};
